import { Popover, styled } from '@mui/material';

import CalendarMonth from '@common/assets/icons/CalendarMonth.svg';

export const StyledDatePickerWrap = styled('div')(() => ({
	display: 'flex',
	alignItems: 'center',

	gap: '8px',
	flexBasis: '100%',
	justifyContent: 'center',
}));

export const StyledDatePickerPopover = styled(Popover)({});

export const StyledDatePickerCalendarMonth = styled(CalendarMonth)(({ theme }) => ({
	color: theme.palette.primary.main,
	cursor: 'pointer',
}));
